import {
  CardInfo,
  cardInfoFromResponse,
} from '../interfaces/Checkout/CardInfo';
import api, { apiPrefix } from './Api';

export const getCardInfo = async (cardNumber: string): Promise<CardInfo> => {
  const bodyFormData = new FormData();
  bodyFormData.append('cardNumber', cardNumber);

  const response = await api.post(`${apiPrefix}/getCardType`, bodyFormData);

  return cardInfoFromResponse(response.data);
};
